export const surveysData = {
  items: [
    {
      id: '366',
      organization: 'Wayne Enterprises Inc',
      name: 'Employee Survey 2022',
      status: 'active',
      endDate: '2022-11-26',
      type: 'ADAPT',
    },
    {
      id: '211',
      organization: 'Acme',
      name: 'Employee Survey Q3 2022',
      status: 'active',
      endDate: '2022-09-26',
      type: 'ADAPT',
    },
    {
      id: '197',
      organization: 'Acme',
      name: 'Employee Survey Q2 2022',
      status: 'inactive',
      endDate: '2022-06-15',
      type: 'ADAPT',
    },
    {
      id: '164',
      organization: 'Acme',
      name: 'Employee Survey Q1 2022',
      status: 'inactive',
      endDate: '2022-03-20',
      type: 'ADAPT',
    },
    {
      id: '255',
      organization: 'Wayne Enterprises Inc',
      name: 'Employee Survey 2021',
      status: 'inactive',
      endDate: '2021-05-26',
      type: 'ADAPT',
    },
  ],
};

export const createSurveyArrMock = [
  { id: '1', name: 'Age' },
  { id: '2', name: 'Gender' },
  { id: '3', name: 'Education' },
  { id: '4', name: 'Proffessional Category' },
];

export const accordionMenuMock = [
  {
    id: '1',
    name: 'demographics',
    topics: [
      { id: 'p1', name: 'Age', scrollTo: '#someid' },
      { id: 'p2', name: 'Gender', scrollTo: '#someid' },
      { id: 'p3', name: 'education', scrollTo: '#someid' },
      { id: 'p4', name: 'Profession category', scrollTo: '#someid' },
    ],
  },
  {
    id: '2',
    name: 'Predictive states',
    topics: [
      { id: 'p1', name: 'Age', scrollTo: '#someid' },
      { id: 'p2', name: 'Gender', scrollTo: '#someid' },
      { id: 'p3', name: 'education', scrollTo: '#someid' },
      { id: 'p4', name: 'Profession category', scrollTo: '#someid' },
    ],
  },
  {
    id: '3',
    name: 'Predictability',
    topics: [
      { id: 'p1', name: 'Age', scrollTo: '#someid' },
      { id: 'p2', name: 'Gender', scrollTo: '#someid' },
    ],
  },
  {
    id: '4',
    name: 'competence, development',
    topics: [
      { id: 'p1', name: 'Age', scrollTo: '#someid' },
      { id: 'p2', name: 'Gender', scrollTo: '#someid' },
    ],
  },
];

export const participantsDataMock = {
  items: [
    {
      id: '112',
      name: 'Joshamee Gibbs',
      emailAddress: 'jgordon@gcpd.com',
      phoneNo: '(+48) 555-555-555',
      preferredLanguage: 'en',
      team: 'Black Pearl',
      leader: 'Jack Sparrow',
      status: { code: 'invited', datetime: '2018-04-30T12:15:00Z' },
    },
    {
      id: '111',
      name: 'Pintel ',
      emailAddress: 'pintel@poftc.com',
      preferredLanguage: 'en',
      team: 'Black Pearl',
      leader: 'Jack Sparrow',
      status: { code: 'invited', datetime: '2018-04-30T12:15:00Z' },
    },
    {
      id: '110',
      name: 'Ragetti ',
      emailAddress: 'ragetti@poftc.com',
      preferredLanguage: 'en',
      team: 'Black Pearl',
      leader: 'Jack Sparrow',
      status: { code: 'invited', datetime: '2018-04-30T12:15:00Z' },
    },
    {
      id: '109',
      name: 'Mullroy',
      emailAddress: 'mullroy@hmsint.com',
      preferredLanguage: 'en',
      team: 'HMS Interceptor',
      leader: 'James Norrington',
      status: { code: 'invited', datetime: '2018-04-30T12:15:00Z' },
    },
    {
      id: '108',
      name: 'Murtogg',
      emailAddress: 'murtogg@hmsint.com',
      preferredLanguage: 'en',
      team: 'HMS Interceptor',
      leader: 'James Norrington',
      status: { code: 'invited', datetime: '2018-04-30T12:15:00Z' },
    },
  ],
  pagingInfo: {
    pageNo: 1,
    itemsPerPage: 20,
    totalPageCount: 5,
    totalItemsCount: 100,
  },
};

export const pagingInfoMock = {
  pageNo: 1,
  itemsPerPage: 20,
  totalPageCount: 5,
  totalItemsCount: 100,
  memberCount: 2,
  subordinateCount: 5,
  superordinateCount: 1,
  leaderCount: 1,
  teamReportsCount: 1,
  executiveReportsCount: 1,
};

export const reportsGroupMock = [
  {
    id: '1024',
    name: 'Black Pearl',
    type: 'team',
    memberCount: {
      participants: 4,
    },
  },
  {
    id: '1023',
    name: 'HMS Interceptor',
    type: 'team',
    memberCount: {
      participants: 2,
    },
  },
  {
    id: '1022',
    name: 'Sailors',
    type: 'executive',
    memberCount: {
      participants: 20,
    },
  },
  {
    id: '1021',
    name: 'Pirates',
    type: 'executive',
    memberCount: {
      participants: 0,
    },
  },
  {
    id: '1020',
    name: 'Royal Navy',
    type: 'executive',
    memberCount: {
      participants: 150,
    },
  },
];

export const reportSetupMembersMock = {
  items: [
    {
      id: '1',
      name: 'Name',
      emailAddress: 'name@example.com',
      team: 'Team Name',
      leader: 'Leader Name',
    },
    {
      id: '1',
      name: 'Name',
      emailAddress: 'name@example.com',
      team: 'Team Name',
      leader: 'Leader Name',
    },
    {
      id: '1',
      name: 'Name',
      emailAddress: 'name@example.com',
      team: 'Team Name',
      leader: 'Leader Name',
    },
    {
      id: '1',
      name: 'Name',
      emailAddress: 'name@example.com',
      team: 'Team Name',
      leader: 'Leader Name',
    },
  ],
  pagingInfo: pagingInfoMock,
};
